<template>
  <div class="sm-products-grid" :class="container_class">
    <div v-for="product in curProducts" class="sm-product" :class="product_class">
      <a
          class="sm-product__image-wrapper"
          :href="product.link_url"
          tabindex="-1"
          target="_blank">
        <div class="sm-product__labels">
          <div v-if="product.attributes.наличие === ''" class="badge sm-product__unavailable">Нет в наличии</div>
          <div v-else-if="(product.oldPrice - product.price) > 10" class="badge sm-product__discount">
            Скидка {{ formatPrice(product.oldPrice - product.price) }}
            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.88672 5.68555V6.5293H5.32617V7.33789H1.88672V9.5H0.75V7.33789H0.164062V6.5293H0.75V5.68555H0.164062V4.70117H0.75V0.910156H3.43945C4.20898 0.910156 4.79102 0.988281 5.18555 1.14453C5.58398 1.29688 5.90234 1.56836 6.14062 1.95898C6.37891 2.34961 6.49805 2.78125 6.49805 3.25391C6.49805 3.73047 6.41016 4.125 6.23438 4.4375C6.05859 4.75 5.82422 5 5.53125 5.1875C5.24219 5.37109 4.9082 5.5 4.5293 5.57422C4.1543 5.64844 3.76562 5.68555 3.36328 5.68555H1.88672ZM3.36328 4.70117C3.625 4.70117 3.875 4.68164 4.11328 4.64258C4.35156 4.59961 4.56055 4.52344 4.74023 4.41406C4.91992 4.30469 5.0625 4.1582 5.16797 3.97461C5.27344 3.78711 5.32617 3.54688 5.32617 3.25391C5.32617 3 5.27734 2.78516 5.17969 2.60938C5.08594 2.43359 4.95508 2.29102 4.78711 2.18164C4.62305 2.06836 4.42969 1.98633 4.20703 1.93555C3.98438 1.88477 3.74414 1.85938 3.48633 1.85938H1.88672V4.70117H3.36328Z" fill="white"></path></svg>
          </div>
          <div v-else-if="product.attributes.хит === 'да'" class="badge sm-product__hit">Хит</div>
          <div v-else-if="product.attributes.новинка === 'да'" class="badge sm-product__new">Новинка</div>
          <div v-else-if="product.attributes.предзаказ === 'да'" class="badge sm-product__order">Под заказ</div>
        </div>
        <img alt=""
             class="sm-product__image"
             :src="product.image_url"></a>
      <div class="sm-product__main">
        <div class="sm-product__meta">
          <div class="sm-product__headline">
            <div class="sm-product__article">Артикул: {{product.attributes.артикул}}</div> <!---->
          </div>
          <a class="sm-product__label" :href="product.link_url"
             target="_blank">{{ product.name }}</a>
        </div>
        <div class="sm-product__price">
          <span class="sm-product-price-variant sm-product-price-variant_actual">{{ formatPrice(product.price) }}
            <span class="sm-product-price-variant__currency">
              <svg fill="none" height="11" viewBox="0 0 8 11" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.55078 7.63672V9.14746H2.83691V11H0.813477V9.14746H0.136719V7.63672H0.813477V6.81641H0.136719V5.2168H0.813477V0.978516H3.69824C4.77376 0.978516 5.55078 1.06966 6.0293 1.25195C6.51237 1.42969 6.90202 1.7487 7.19824 2.20898C7.48991 2.66471 7.63574 3.19108 7.63574 3.78809C7.63574 4.27572 7.57422 4.69043 7.45117 5.03223C7.33268 5.36947 7.16862 5.64974 6.95898 5.87305C6.74935 6.09635 6.50098 6.27181 6.21387 6.39941C5.92676 6.52702 5.61458 6.62272 5.27734 6.68652C4.9401 6.74577 4.58691 6.78223 4.21777 6.7959C3.85319 6.80957 3.48405 6.81641 3.11035 6.81641H2.83691V7.63672H5.55078ZM2.83691 5.2168H2.95996C3.93066 5.2168 4.53678 5.17578 4.77832 5.09375C5.02441 5.01172 5.21354 4.87044 5.3457 4.66992C5.48242 4.4694 5.55078 4.21875 5.55078 3.91797C5.55078 3.57617 5.46419 3.30273 5.29102 3.09766C5.11784 2.88802 4.86035 2.75814 4.51855 2.70801C4.43652 2.69889 4.27246 2.69206 4.02637 2.6875C3.78483 2.67839 3.45671 2.67383 3.04199 2.67383H2.83691V5.2168Z" fill="#4C4960"></path>
              </svg>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import helpers from "../../store/helpers";

export default {
  name: "products-grid",
  props: {
    'container_class': '',
    'product_class': '',
    'per_page': 0
  },
  data: function () {
    return {
      per_page_local: this.per_page
    }
  },
  computed: {
    ...mapGetters("search", ["products"]),
    curProducts: function () {
      let products = this.products;
      products = JSON.parse(JSON.stringify(products))
      return (this.per_page_local > 0) ? products.slice(0, this.per_page_local) : products;
    },
  },
  methods: {
    formatPrice: function (price) {
      const formatter = helpers.formatter();
      return formatter.format(price);
    }
  }
}
</script>